module.exports = __webpack_public_path__ + "55580ab5a8a4ca70b3a5fb923881f826.png";